import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import type { Site } from '@hotjar/site';
import type { ResponseLimitInfo } from './ResponseLimitInfo';
import { getResponseLimitInfo } from './api';

const RESPONSES_LIMIT_QUERY_KEY = 'responses_limit';

export const useResponseLimitInfoQuery = ({
  site,
  isEnabled,
}: {
  site?: Site;
  isEnabled?: boolean;
}): UseQueryResult<ResponseLimitInfo | undefined, Error> => {
  return useQuery(
    [RESPONSES_LIMIT_QUERY_KEY, { siteId: site?.id }],
    () => getResponseLimitInfo(site),
    {
      enabled: Boolean(site?.id) && isEnabled !== false,
      staleTime: 10000,
      refetchInterval: 10000,
    },
  );
};
